import { QueryClient } from "@tanstack/react-query";
import { isAxiosError } from "axios";

const MAX_RETRIES = 3;
const HTTP_STATUS_TO_NOT_RETRY: number[] = [400, 401, 403, 404];

export function generateQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // onError: queryErrorHandler,
        // refetchOnMount: false,
        staleTime: 1000 * 60 * 5,
        refetchOnWindowFocus: true,
        refetchOnReconnect: false,
        retry: (failureCount, error) => {
          // Shouldn't retry with status: 400, 401, 403, 404
          if (failureCount > MAX_RETRIES) {
            return false;
          }
          if (
            isAxiosError(error) &&
            HTTP_STATUS_TO_NOT_RETRY.includes(error.response?.status ?? 0)
          ) {
            console.log(
              `Aborting retry due to ${error.response?.status} status`
            );
            return false;
          }
          return true;
        },
      },
    },
  });
}

export const queryClient = generateQueryClient();
